import { render, staticRenderFns } from "./EnergyColorPalette.vue?vue&type=template&id=4a1aca0e&scoped=true"
import script from "./EnergyColorPalette.vue?vue&type=script&lang=js"
export * from "./EnergyColorPalette.vue?vue&type=script&lang=js"
import style0 from "./EnergyColorPalette.vue?vue&type=style&index=0&id=4a1aca0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1aca0e",
  null
  
)

export default component.exports